// extracted by mini-css-extract-plugin
export default {"deleteButton":"teacher-note-edit_deleteButton__ZCwDN"};